import { Typography } from "@mui/material"
import Box from "@mui/material/Box"
import SessionsHorizontalList from "components/SessionsHorizontalList"
import { ActivityIndicator } from "components/activity-indicator"
import useCurrent from "lib/use-current"
import Convention from "models/convention-api/v1/Convention"
import ConventionSessionCount from "models/convention-api/v1/ConventionSessionCount"
import { useRouter } from "next/router"

interface ISessionsListGrouped {
  institutionId: string
  exhibitorId: string
}

const SessionsListGrouped = (props: ISessionsListGrouped) => {
  const { institutionId, exhibitorId } = props

  const { query } = useRouter()

  const current = useCurrent()
  // @ts-ignore
  const { config } = current

  const { data: conventionsData } = Convention.useAll({
    filter: {
      exhibitor_id: exhibitorId,
      upcoming: "true",
    },
  })

  const { data: conventionSessionCounts } = ConventionSessionCount.useAll({
    filter: {
      institution_id: institutionId,
      when: `now_and_upcoming`,
    },
  })

  if (!conventionsData || !conventionSessionCounts) {
    return (
      <Box display="flex" flexDirection="column" minHeight="400px">
        <ActivityIndicator />
      </Box>
    )
  }

  const conventions = conventionsData.map((convention) => {
    const sessionCount = conventionSessionCounts.find(
      (countData) => countData.convention_id == convention.id,
    )?.session_count

    return {
      id: convention.id,
      name: convention.name,
      session_count: sessionCount || 0,
    }
  })

  const amountOfSessions = conventions.reduce((store, current) => store + current.session_count, 0)

  return (
    <>
      {!query.convention_id && amountOfSessions === 0 && (
        <Box>
          <Typography variant={"h6"}>Upcoming {config.session_copy_text}s (0)</Typography>
          <Typography style={{ marginTop: "8px" }}>No upcoming live sessions...</Typography>
        </Box>
      )}
      {conventions.map((convention) => {
        if (query.convention_id && query.convention_id != convention.id) {
          return null
        } else if (!query.convention_id && !convention.session_count) {
          return null
        } else {
          return (
            <SessionsHorizontalList
              key={convention.id}
              institutionId={institutionId}
              convention={convention}
            />
          )
        }
      })}
    </>
  )
}

export default SessionsListGrouped
